export const getRequiredOpenCostQuantity = (
  quantity: number | string,
  minAmountValue: number | string
) => {
  const amount = !quantity ? 0 : +quantity >= +minAmountValue ? +quantity : 0;
  return amount || 1;
};
